import React, { useState } from 'react';
import { Download } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { ExportDialog } from './ExportDialog';
import type { Student } from '../types/student';

interface ExportButtonProps {
  students: Student[];
  isLoading?: boolean;
  searchTerm?: string;
  filters?: {
    status?: string;
    curso?: string;
    dataInicio?: string;
    dataFim?: string;
    acessoFiltro?: string;
  };
}

export function ExportButton({ 
  students, 
  isLoading = false,
  searchTerm = '',
  filters = {}
}: ExportButtonProps) {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <Button
        onClick={() => setDialogOpen(true)}
        disabled={isLoading}
        className="px-4 py-2 bg-[#268c73] text-white rounded-lg flex items-center gap-2 hover:bg-[#1a7a61] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <Download className="w-4 h-4" />
        Exportar dados
      </Button>

      <ExportDialog
        open={dialogOpen}
        onOpenChange={setDialogOpen}
        students={students}
        currentFilters={filters}
        searchTerm={searchTerm}
      />
    </>
  );
}